import { PayloadAction } from '@reduxjs/toolkit';
import { DTO__user_settings } from '@shared/dto/+user/user_settings/DTO__user_settings';
import { ENUM__redux_action } from '../../_base/ENUM__redux_action';
import { StateUser } from '../state_user';

export const local_user_settings_upsert = (payload: DTO__user_settings): PayloadAction<DTO__user_settings> => ({
  type: ENUM__redux_action.USER_SETTINGS_UPSERT,
  payload,
});

export const init_local_user_settings_upsert = (state: StateUser, action: PayloadAction<DTO__user_settings>) => {
  state.user_settings = action.payload.clone();
};
